import React, { useEffect, useState } from "react";
import ImageGallery from "react-image-gallery";
import axios from "axios";
import { Row, Col, Container, ListGroup, Button, Form, Table } from "react-bootstrap";

const QuotedItemPreviewComponent = ({
  quotedItem
}) => {
  //react-image-lightbox -starts here
  async function fetchImage(url) {
    try {
      const response = await fetch(url);
      return response;
    } catch (error) {
      console.error(
        "There has been a problem with your fetch operation:",
        error
      );
    }
  }

  const [images, setImages] = useState([]);
  useEffect(() => {
    async function handleImages() {
      const imagesArray = [];
      if (quotedItem && quotedItem.clientImages) {
        for (const image of quotedItem.clientImages) {
          let imagePath = image.path;

          if (imagePath.includes("http://")) {
            imagePath = imagePath.replace("http://", "https://");
          }
          const isExists = await fetchImage(imagePath);
          if (isExists.ok) {
            imagesArray.push({
              original: imagePath,
              thumbnail: imagePath,
              url: imagePath,
              title: image.title,
              caption: image.name,
            });
            // console.log(imagesArray);
          }
        }
      }
      setImages(imagesArray);
    }
    handleImages();
  }, [quotedItem]);

  const formatDateTime = (value) =>
    value ? new Date(value).toLocaleString() : "—";

  return (
    <>
      <Container className="mt-3" fluid>
        <Row className="">
          <Col lg={6} className="">
            <ImageGallery items={images} />
          </Col>
          <Col lg={6}>
            <Row>
              <Col xs={12} md={12} lg={12}>
                <Table responsive bordered size="lg">
                  <caption className="visually-hidden">Quote details</caption>
                  <tbody>
                    <tr>
                      <th scope="row">Product Name</th>
                      <td>{quotedItem?.name ?? "—"}</td>
                    </tr>
                    <tr>
                      <th scope="row">Product Description</th>
                      <td>{quotedItem?.userDescription ?? "—"}</td>
                    </tr>
                    <tr>
                      <th scope="row">Quote Type</th>
                      <td>{(String(quotedItem?.quoteType ?? '') || '—').replace(/_/g, ' ')}</td>
                    </tr>
                    <tr>
                      <th scope="row">Quote Status</th>
                      <td>{quotedItem?.status ?? "—"}</td>
                    </tr>
                    <tr>
                      <th scope="row">Created Date</th>
                      <td>{formatDateTime(quotedItem?.createdAt)}</td>
                    </tr>
                    <tr>
                      <th scope="row">Updated Date</th>
                      <td>{formatDateTime(quotedItem?.updatedAt)}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>

  )
}

export default QuotedItemPreviewComponent;